export default "__VITE_ASSET__CbJ0AaRr__"